<template>
  <div>
    <div v-if="step === 1">
      <div>
        <h1>Looks like we need a little bit of information...</h1>
      </div>
      <div class="signupText">
        <label for="fullname">Name: </label>
        <input
          class="nameInput"
          type="text"
          name="fullname"
          v-model="fullname"
          placeholder="First and Last name"
        />
      </div>
      <div class="signupText">
        <label for="email">Email: </label>
        <input
          class="emailInput"
          type="text"
          name="email"
          v-model="email"
          placeholder="johndoe@yahoo.com"
        />
      </div>
      <div>
        <button class="btn" @click="getOtp">Sign up</button>
      </div>
    </div>
    <div v-else-if="step === 2">
      <div>
        <h1>Please check your email for a one time passcode</h1>
        <v-otp-input
          class="otpEmailInput"
          ref="otpInput"
          input-classes="otp-input"
          separator="-"
          :num-inputs="5"
          @on-change="handleOnChange"
        />
        <button class="btn" @click="register" :disabled="!otpComplete">Sign up</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import OtpInput from '@bachdgvn/vue-otp-input'
export default {
  components: {
    'v-otp-input': OtpInput
  },
  data () {
    return {
      fullname: '',
      email: '',
      step: 1,
      otpComplete: false
    }
  },
  methods: {
    ...mapActions(['user']),
    handleOnChange () {
      if (this.$refs.otpInput.otp.join('').length !== 5) {
        this.otpComplete = false
      } else {
        this.otpComplete = true
      }
    },
    getOtp () {
      const otpURI = '/auth/otp'
      const data = {
        email: this.email
      }
      this.$axios
        .post(otpURI, data)
        .then((result) => {
          this.step = 2
          console.log(result)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    register () {
      const registerURI = '/auth/register'
      const data = {
        email: this.email,
        otp: this.$refs.otpInput.otp.join(''),
        username: this.fullname
      }
      this.$axios
        .post(registerURI, data)
        .then((result) => {
          this.user(result.data.data)
          this.$router.push('/onboarding')
          console.log(result)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>
<style scoped>
.container {
  display: block;
  justify-content: center;
  height: 100%;
}
.btn {
  width: 139px;
  height: 52px;
  margin-top: 65px;
  background: linear-gradient(
    96.18deg,
    #03a3f5 -5.4%,
    #b983ff 50.72%,
    #ffe883 85.14%
  );
  box-shadow: 0px 7px 10px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  border: 0px;
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  color: #ffffff;
  cursor: pointer;
}

.signupText {
  margin-top: 20px;
}

.nameInput {
  color: #333;
  font-size: 1.2rem;
  margin: 13px auto;
  padding: 1rem;
  border-radius: 0.2rem;
  background-color: rgb(255, 255, 255);
  border: 2px solid #03a3f5;
  width: 60%;
  display: block;
  transition: all 0.3s;
}

.emailInput {
  color: #333;
  font-size: 1.2rem;
  margin: 13px auto;
  padding: 1rem;
  border-radius: 0.2rem;
  background-color: rgb(255, 255, 255);
  border: 2px solid #b983ff;
  width: 60%;
  display: block;
  transition: all 0.3s;
}

.otpEmailInput {
  justify-content: center;
  margin-top: 25px;
}
</style>
